module.exports = __webpack_public_path__ + "static/img/andar.f23a627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gamecompetition/andar.png
// module id = u9l7
// module chunks = 0